import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaXTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTiktok,
  FaWhatsapp,
  FaChevronDown
} from "react-icons/fa6";
import { supabase } from "../admin/supabase";
import { getSiteSettings } from "../siteSettings";
import { resolveSocialLinks } from "../socialLinks";


export default function TopBar() {
  const [siteSettings, setSiteSettings] = useState(null);
  // Which quick-link dropdown is open (touch devices can't :hover, so the
  // menus are tap-toggled). Only one can be open at a time.
  const [openMenu, setOpenMenu] = useState(null);
  const topbarRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    const loadSettings = async () => {
      const settings = await getSiteSettings(supabase);
      if (isMounted) setSiteSettings(settings);
    };

    loadSettings();
    return () => { isMounted = false; };
  }, []);

  // Close the open dropdown on any tap/click outside the topbar and on Escape.
  useEffect(() => {
    if (!openMenu) return undefined;

    const handleOutside = (e) => {
      if (topbarRef.current && !topbarRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    const handleKey = (e) => {
      if (e.key === "Escape") setOpenMenu(null);
    };

    document.addEventListener("click", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("click", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [openMenu]);

  const toggleMenu = (name) => (e) => {
    e.preventDefault();
    setOpenMenu((current) => (current === name ? null : name));
  };

  const dropdownProps = (name) => ({
    className: `top-dropdown${openMenu === name ? " open" : ""}`,
  });

  const triggerProps = (name) => ({
    onClick: toggleMenu(name),
    "aria-haspopup": "true",
    "aria-expanded": openMenu === name,
  });

  const socialLinks = resolveSocialLinks(siteSettings);

  return (
    // <div className="topbar" style={{ backgroundColor: siteSettings?.primary_color || undefined, color: siteSettings?.secondary_color || undefined }}>
    <div className="topbar" ref={topbarRef}>
      <div className="container">

        <div className="left">

          <a href="tel:+254719034500" className="tb-phone" aria-label="Call Zetech University on +254 719 034 500">
            <FaPhone aria-hidden="true" />
            <span className="tb-label">+254 719 034 500</span>
          </a>

          <a href="https://wa.me/254110097375" target="_blank" rel="noopener noreferrer" className="tb-whatsapp" aria-label="Chat with Zetech University on WhatsApp">
            <FaWhatsapp aria-hidden="true" />
            <span className="tb-label">+254 110 097 375</span>
          </a>

          <a href={`mailto:${siteSettings?.contact_email || "info@zetech.ac.ke"}`} className="tb-email" aria-label={`Email ${siteSettings?.contact_email || "info@zetech.ac.ke"}`}>
            <FaEnvelope aria-hidden="true" />
            <span className="tb-label">{siteSettings?.contact_email || "info@zetech.ac.ke"}</span>
          </a>

        </div>

        <div className="right">
          <div className="links">

            
            {/* Students */}
            <div {...dropdownProps("students")}>
              <button type="button" className="top-dropdown-trigger" {...triggerProps("students")}>
                Students
                <FaChevronDown className="arrow" aria-hidden="true" />
              </button>

              <ul className="top-dropdown-menu">
                <li><a href="https://student.zetech.ac.ke">Student Portal</a></li>
                <li><a href="https://tathmini.zetech.ac.ke">Tathmini</a></li>
                <li><a href="https://hatua.zetech.ac.ke">Hatua</a></li>
                <li><a href="https://shahada.zetech.ac.ke">Shahada</a></li>
              </ul>
            </div>

            {/* Staff */}
            <div {...dropdownProps("staff")}>
              <button type="button" className="top-dropdown-trigger" {...triggerProps("staff")}>
                Staff
                <FaChevronDown className="arrow" aria-hidden="true" />
              </button>

              <ul className="top-dropdown-menu">
                <li><a href="https://profiles.zetech.ac.ke">Staff Profiles</a></li>
                <li><a href="https://zera.zetech.ac.ke">ZERA</a></li>
              </ul>
            </div>

            {/* Alumni */}
            <div {...dropdownProps("alumni")}>
              <button type="button" className="top-dropdown-trigger" {...triggerProps("alumni")}>
                Alumni
                <FaChevronDown className="arrow" aria-hidden="true" />
              </button>

              <ul className="top-dropdown-menu">
                <li><a href="https://alumni.zetech.ac.ke">Alumni Relations</a></li>
                <li><Link to="/testimonials">Alumni Testimonials</Link></li>
              </ul>
            </div>


            <a href="https://elearning.zetech.ac.ke/my/courses.php">E-Learning</a>

            <a href="https://library.zetech.ac.ke/">Library</a>

            <a href="https://careers.zetech.ac.ke/">Careers</a>

          </div>

          <div className="social">
            <a href={socialLinks.facebook} target="_blank" rel="noreferrer" aria-label="Zetech University on Facebook"><FaFacebookF /></a>
            <a href={socialLinks.twitter} target="_blank" rel="noreferrer" aria-label="Zetech University on X (Twitter)"><FaXTwitter /></a>
            <a href={socialLinks.instagram} target="_blank" rel="noreferrer" aria-label="Zetech University on Instagram"><FaInstagram /></a>
            <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" aria-label="Zetech University on LinkedIn"><FaLinkedinIn /></a>
            <a href={socialLinks.youtube} target="_blank" rel="noreferrer" aria-label="Zetech University on YouTube"><FaYoutube /></a>
            <a href={socialLinks.tiktok} target="_blank" rel="noreferrer" aria-label="Zetech University on TikTok"><FaTiktok /></a>
          </div>

        </div>

      </div>
    </div>
  );
}
